module.exports = __webpack_public_path__ + "media/Video 16.208571ab.mp4";